import type { ThemeFonts } from 'fitify-ui-onboarding/src/types/theme'
import { Noto_Sans, Poppins } from 'next/font/google'

const poppins = Poppins({
  weight: ['400', '500', '600', '700'],
  subsets: ['latin', 'latin-ext'],
  display: 'swap',
})

const notoSans = Noto_Sans({
  display: 'swap',
  preload: false,
  adjustFontFallback: false,
})

const createThemeFonts = (companionFontFamily?: string): ThemeFonts => {
  const [primaryFontFamily, ...fallbackFontFamilies] =
    poppins.style.fontFamily.split(', ')
  const fontFamily = [
    primaryFontFamily,
    ...(companionFontFamily ? [companionFontFamily] : []),
    ...fallbackFontFamilies,
  ].join(', ')
  return {
    heading: fontFamily,
    text: fontFamily,
  }
}

export const getOnboardingFonts = (language: string): ThemeFonts => {
  switch (language) {
    case 'ja':
      return createThemeFonts("'Noto Sans JP'")
    case 'ko':
      return createThemeFonts("'Noto Sans KR'")
    case 'ru':
      return createThemeFonts(notoSans.style.fontFamily)
    default:
      return createThemeFonts()
  }
}
